import { FC } from 'react';

import Table from 'modules/_shared/Table';

import CoOwnersTableBody from './CoOwnersTableBody';
import CoOwnersTableHeader from './CoOwnersTableHeder';

const CoOwnersTable: FC = () => {
  const content = (
    <>
      <CoOwnersTableHeader />
      <CoOwnersTableBody />
    </>
  );

  return <Table content={content} />;
};

export default CoOwnersTable;
